import {Pipe, PipeTransform} from '@angular/core';
import moment from 'moment';

@Pipe({
  name: 'prettyTime'
})
export class PrettyTimePipe implements PipeTransform {
  transform(input: any, allowNegative?: any, showDays?: any): any {
    if (input) {
      let duration = moment.duration(input >= 0 ? input : 0);
      let negativeSymbol = '';
      if (allowNegative) {
        duration = moment.duration(Math.abs(input));
        if (input < 0) {
          negativeSymbol = '-';
        }
      }
      let hours = '';
      let days = '';
      if (Math.floor(duration.asHours()) > 0) {
        if (showDays && duration.asHours() >= 24) {
          days = Math.floor(duration.asDays()) + 'd ';
          hours = Math.floor(duration.hours()) + 'h ';
        } else {
          hours = Math.floor(duration.asHours()) + 'h ';
        }
      }
      return negativeSymbol + days + hours + duration.minutes() + 'm';
    } else {
      return '0m';
    }
  }
}
